import { constant as defaultApiEndpoints } from 'tmr/constants/defaultApiEndpoints'

export const constant = [
  defaultApiEndpoints[0],
  Object.assign(defaultApiEndpoints[1], {}),
]
